import { QueryClient } from "@tanstack/react-query";
import { TeachersAvailabilityApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchSpecialHours(
  teacherId: number,
  queryClient: QueryClient,
  accessToken: string,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.SpecialHours, teacherId, 1, 100, undefined, undefined],
    queryFn: async () => {
      const service = createAuthenticatedApi(
        TeachersAvailabilityApi,
        accessToken,
      );
      return await service.apiAvailabilityTeacherIdSpecialAppointmentHoursGet({
        teacherId,
        page: 1,
        pageSize: 100,
      });
    },
    staleTime: 5 * 60 * 1000,
  });
}

